<section class="add-comment-dialog">
    <div class="uscb-layout-row uscb-bg-primary uscb-color-white">
        <span class="vcenter uscb-flex uscb-padding-TB-0 uscb-padding-LR-10">
            @if (!fullCaseID.slice(16).includes('OM-')) {
            <ng-container>POST NEW COMMENT</ng-container>
            }
            @if (fullCaseID.slice(16).includes('OM-')) {
            <ng-container>SEND A MESSAGE</ng-container>
            }
        </span>
        <span class="vcenter">
            <mat-icon (click)="close(true)" (keyup.enter)="close(true)" tabindex="0" aria-hidden="false">close</mat-icon>
        </span>
    </div>

    <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
        <mat-dialog-content>
            <div class="my-dialog-content">
                <textarea class="uscb-width-100" name="comment" id="comment" rows="3" formControlName="comment" id="comment"
                    cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3" cdkAutosizeMaxRows="5"
                    placeholder="Enter Your Message Here" (blur)="commentAfterBlur.set(true)" tabindex="0" maxlength="2500" #descRef1>
            </textarea>
                <div>
                    @if (showError('comment') && commentAfterBlur()) {
                    <mat-error class="red-text-darker">Please enter your comments</mat-error>
                    }
                </div>
                <div>
                    @if (hasError()) {
                    <mat-error class="red-text-darker">{{errorMessage()}}</mat-error>
                    }
                </div>
                <div class="counter">
                    {{ descRef1.value.length }}/2500
                </div>
                @if (!hasError()) {
                <div class="ecorr-padding-TOP-sm uscb-padding-L-2 uscb-font-sm">
                    <b>Note:</b>
                    Any messages submitted with HTML will be converted to plain text.
                </div>
                <div class="indent-txt">
                    <div class="uscb-flex-row uscb-margin-T-10">
                        @if (currentFiles().length > 0) {
                        <div>
                            @for (item of currentFiles(); track item; let i = $index) {
                            <div class="uscb-bold uscb-margin-2">
                                <i class="fa" [ngClass]="getFileIcon(item.name)"></i>
                                &nbsp;&nbsp; {{item.name}} &nbsp;&nbsp;
                                <i class="fa fa-times fa-1x" (click)="removeFile(i)" (keyup.enter)="removeFile(i)" tabindex="0"></i>
                            </div>
                            }
                        </div>
                        }
                    </div>
                </div>
                }
            </div>
        </mat-dialog-content>

        @if (isSubmitDisabled()) {
        <div class="uscb-transparent-button uscb-text-align-center" role="alert" aria-label="Please wait for post to complete">
            PLEASE WAIT... &nbsp;&nbsp; <i class="fa fa-spinner fa-spin"></i>
        </div>
        }

        <mat-dialog-actions class="uscb-layout-row uscb-layout-align-center-center">
            <button class="uscb-secondary-button" [disabled]="isSubmitDisabled()" type="button"
                (click)="cancel()" (keyup.enter)="cancel()" tabindex="0">{{addCommentDialogData.cancelButtonLabel}}
            </button>
            @if (!hasError()) {
            <ng-container>
                <button [disabled]="!canSubmit()" class="uscb-primary-button uscb-margin-LR-10" type="submit"
                    (click)="submitClicked.set(true)" (keyup.enter)="submitClicked.set(true)" tabindex="0">
                    @if (!isSubmitDisabled()) {
                    <ng-container class="md-subhead">{{addCommentDialogData.confirmButtonLabel}}
                    </ng-container>
                    }
                    @if (isSubmitDisabled()) {
                    <ng-container role="alert" aria-label="Please wait for post to complete">PLEASE WAIT...</ng-container>
                    }
                </button>

                <input id="ecorr-button-attachment" class="uscb-secondary-button uscb-margin-5 uscb-hide" multiple="true"
                    (change)="fileChanged($event)" type="file" [disabled]="isSubmitDisabled()"
                    accept=".zip, .pdf,.png,.jpg,.jpeg,.txt,.rtf,.csv,.xls,.xlsx,.doc,.docx,.ppt,.pptx,.tif,.tiff,.gif,.bmp,.odt,.ods"
                    id="files" 
                    name="files"
                    #attachmentInput>

                <button class="uscb-secondary-button" type="button" (click)="attachmentInput.click()" (keyup.enter)="attachmentInput.click()"
                    [disabled]="isSubmitDisabled()" tabindex="0">
                    <i class="fa fa-plus-circle"></i> &nbsp; ADD ATTACHMENT
                </button>
            </ng-container>
            }
        </mat-dialog-actions>
    </form>
</section>
